import React from 'react';
import { useTranslation } from 'react-i18next';
import AnimalType from '../../../../../../enums/animal-type';
import { route } from '../../../../../../services/utils';
import {
  LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_CREATE,
  LIVESTOCK_ANIMALS_GRAZING_CREATE,
  LIVESTOCK_ANIMALS_OTHER_CREATE,
  LIVESTOCK_ANIMALS_PREGNANCY_CHECK_CREATE,
  LIVESTOCK_ANIMALS_SEPARATION_CREATE,
  LIVESTOCK_ANIMALS_BREEDING_CREATE,
  LIVESTOCK_ANIMALS_WEIGHING_CREATE,
} from '../../../../../../router/routes';
import ActionContainer from '../../../../../../components/action-button/container';
import ActionButton from '../../../../../../components/action-button/button';

import pregnancyImage from './pregnancy.svg';
import separationImage from './separation.svg';
import grazingImage from './grazing.svg';
import weighingImage from './weighing.svg';
import starter_feedImage from './starter_feed.svg';
import breedingImage from './breeding.svg';
import otherImage from './other.svg';

export default function AnimalListCreateButtons({
  farmId,
  animals = [],
}: {
  farmId: string;
  animals: string[];
}) {
  const { t } = useTranslation();

  return (
    <>
      <ActionContainer>
        <ActionButton
          name={AnimalType.pregnancy}
          icon={<img src={pregnancyImage} alt="" />}
          route={route(
            LIVESTOCK_ANIMALS_PREGNANCY_CHECK_CREATE.concat(
              '?animals=:animals'
            ),
            {
              animalType: AnimalType.pregnancy,
              farmId,
              animals,
            }
          )}
          text={t('pages.livestock.animals_and_events.animals.types.pregnancy')}
        />
        <ActionButton
          name={AnimalType.separation}
          icon={<img src={separationImage} alt="" />}
          route={route(
            LIVESTOCK_ANIMALS_SEPARATION_CREATE.concat('?animals=:animals'),
            {
              animalType: AnimalType.pregnancy,
              farmId,
              animals,
            }
          )}
          text={t(
            'pages.livestock.animals_and_events.animals.types.separation'
          )}
        />
        <ActionButton
          name={AnimalType.grazing}
          icon={<img src={grazingImage} alt="" />}
          route={route(
            LIVESTOCK_ANIMALS_GRAZING_CREATE.concat('?animals=:animals'),
            {
              animalType: AnimalType.grazing,
              farmId,
              animals,
            }
          )}
          text={t('pages.livestock.animals_and_events.animals.types.grazing')}
        />
        <ActionButton
          name={AnimalType.weighing}
          icon={<img src={weighingImage} alt="" />}
          route={route(
            LIVESTOCK_ANIMALS_WEIGHING_CREATE.concat('?animals=:animals'),
            {
              animalType: AnimalType.weighing,
              farmId,
              animals: animals,
            }
          )}
          text={t('pages.livestock.animals_and_events.animals.types.weighing')}
        />
        <ActionButton
          name={AnimalType.starter_feed}
          icon={<img src={starter_feedImage} alt="" />}
          route={route(
            LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_CREATE.concat(
              '?animals=:animals'
            ),
            {
              farmId,
              animals,
            }
          )}
          text={t(
            'pages.livestock.animals_and_events.animals.types.starter_feed'
          )}
        />
        <ActionButton
          name={AnimalType.breeding}
          icon={<img src={breedingImage} alt="" />}
          route={route(
            LIVESTOCK_ANIMALS_BREEDING_CREATE.concat('?animals=:animals'),
            {
              animalType: AnimalType.breeding,
              farmId,
              animals,
            }
          )}
          text={t('pages.livestock.animals_and_events.animals.types.breeding')}
        />
        <ActionButton
          name={AnimalType.other}
          icon={<img src={otherImage} alt="" />}
          route={route(
            LIVESTOCK_ANIMALS_OTHER_CREATE.concat('?animals=:animals'),
            {
              animalType: AnimalType.other,
              farmId,
              animals,
            }
          )}
          text={t('pages.livestock.animals_and_events.animals.types.other')}
        />
      </ActionContainer>
    </>
  );
}
